"use client";

import { checkAuthAndGetUser } from "@/actions/auth/checkAuthAndGetUser";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  loginRegistrationSuccess,
  logout,
} from "@/store/slices/cred/credSlice";
import { useEffect, useRef } from "react";

/**
 * AuthInitializer - Client component that restores auth state from cookies on app load
 * Should be placed in the root layout, inside ReduxProvider
 */
export function AuthInitializer() {
  const dispatch = useAppDispatch();
  const hasInitialized = useRef(false);
  const { isAuthenticated } = useAppSelector((state) => state.cred);

  useEffect(() => {
    // Only run once on mount
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const initAuth = async () => {
      try {
        const result = await checkAuthAndGetUser();

        if (result.isAuthenticated && result.customer) {
          // Restore auth state to Redux
          dispatch(loginRegistrationSuccess(result.customer));
        } else if (isAuthenticated) {
          // Token is invalid but Redux thinks we're authenticated - logout
          dispatch(logout());
        }
      } catch (error) {
        console.error("[AuthInitializer] Error checking auth:", error);
        // On error, clear any stale auth state
        if (isAuthenticated) {
          dispatch(logout());
        }
      }
    };

    initAuth();
  }, [dispatch, isAuthenticated]);

  // This component doesn't render anything
  return null;
}

export default AuthInitializer;
